import React, {useState} from 'react';
import {useFormik} from 'formik';
import Ebutton from '../../../common/components/Ebutton/Ebutton';
import * as yup from 'yup';
import _ from 'lodash';
import {connect} from 'react-redux';
import actions from '../../../redux/actions';
import {IconButton, InputAdornment} from '@material-ui/core';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import {Input} from '@mui/material';
import './ChangePass.scss';
import {useHistory} from 'react-router-dom';

const InputErrorMessage = ({formik, name, className = ''}) => {
    return (
        <div className={'form-error ' + className} >
            { _.get( formik.touched, name ) && _.get( formik.errors, name ) }
        </div>
    );
};

const ChangePass = (props) => {
    const {
        putChangePasswordRequest,
        showSidebar,
    } = props;

    const [showPassword, setShowPassword] = useState(false);
    const [showRePassword, setShowRePassword] = useState(false);

    const validationSchema = yup.object({
        newPassword: yup
            .string('Ingrese nueva contrasena')
            .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*["#@$!%*?&._+=-])[A-Za-z0-9\\d"#@$!%*?&._+=-]{8,}$/,
                'Debe tener 8 caracteres, con minuscula, mayuscula, numero y caracter especial',
            )
            .required('Ingrese nueva contrasena'),
        oldPassword: yup
            .string('Ingrese contrasena')
            .required('Ingrese contrasena'),
    });
    const history = useHistory();

    const formik = useFormik({
        initialValues: {
            oldPassword: '',
            newPassword: '',
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {
            const body = {
                oldPassword: values.oldPassword,
                newPassword: values.newPassword,
            };
            putChangePasswordRequest(body);
            history.goBack();
        },
    });

    return (
        <div className={showSidebar && window.innerWidth <= 700 ? 'ul-div-background bg-mt-10' : 'ul-div-background'}>
            <div className="ul-div-section">

            <div className="ul-div-sect-header">
                <div>
                    <p className="ul-p-title">Cambiar contraseña</p>
                    <hr id="id-hr"/>
                </div>
            </div>

            <div className="ul-div-form">

                <form className="eu-form" onSubmit={formik.handleSubmit}>

                    <div className="eu-div-container">
                        <div className="eu-div-input width-60">
                            <text className="eu-text-l eu-f-label">Contraseña anterior</text>
                        </div>
                        <div className="eu-div-input width-60">
                            <Input
                                name="oldPassword"
                                type={showPassword ? 'text' : 'password'}
                                onChange={formik.handleChange}
                                value={formik.values.oldPassword}
                                placeholder="Contraseña anterior"
                                className="lg-input-password"
                                endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton
                                            onClick={() => setShowPassword(!showPassword)}
                                        >
                                            {showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                                        </IconButton>
                                    </InputAdornment>
                                }
                            />
                        </div>
                        <div className="eu-div-input width-60 justify-center">
                            <InputErrorMessage formik={formik} name='pass' className='rp-input-l' />
                        </div>

                        <div className="eu-div-input width-60">
                            <text className="eu-text-l eu-f-label">Nueva contraseña</text>
                        </div>
                        <div className="eu-div-input width-60">
                            <Input
                                name="newPassword"
                                type={showRePassword ? 'text' : 'password'}
                                onChange={formik.handleChange}
                                value={formik.values.newPassword}
                                placeholder="Nueva contraseña"
                                className="lg-input-password"
                                endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton
                                            onClick={() => setShowRePassword(!showRePassword)}
                                        >
                                            {showRePassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                                        </IconButton>
                                    </InputAdornment>
                                }
                            />
                        </div>
                        <div className="eu-div-input width-60 justify-center">
                            <InputErrorMessage formik={formik} name='newPassword' className='rp-input-l' />
                        </div>

                        <Ebutton classNameButton="eu-btn" type="submit" text="CAMBIAR"/>
                    </div>

                </form>
            </div>

        </div></div>
    );
};

const mapStateToProps = (state) => ({
    showSidebar: state.common.showSidebar,
});

const mapDispatchToProps = (dispatch) => ({
    putChangePasswordRequest: (body) => dispatch( actions.home.putChangePasswordRequest(body) ),
});


export default connect(mapStateToProps, mapDispatchToProps)(ChangePass);
